import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@material-ui/core";
import { RowItemType } from "./CustomTable";

interface props {
  rows: RowItemType[];
  headers: string[];
}

const SimpleTable = ({ headers, rows }: props) => {
  return (
    <Paper elevation={0}>
      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
              {headers.map((head, index) => (
                <TableCell
                  key={index}
                  align="center"
                  style={{
                    fontWeight: "bold",
                    fontSize: "8pt",
                    lineHeight: "10pt",
                    letterSpacing: "1px",
                  }}
                >
                  {head.toUpperCase()}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((row, index) => (
              <TableRow key={index}>
                {Object.entries(row).map(([key, val], index) => (
                  <TableCell key={index} align="center">
                    {val}
                  </TableCell>
                ))}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Paper>
  );
};
export default SimpleTable;
